import Vue from 'vue';
import Vuex from 'vuex';
import axios from 'axios';

Vue.use(Vuex);

const store = new Vuex.Store({
	state: {
		laws: [],
		totalLaws: 0,
		currentPage: 1,
		itemsPerPage: 10,
		loading: false,
	},
	mutations: {
		setLaws(state, laws) {
			state.laws = laws;
		},
		setTotalLaws(state, totalLaws) {
			state.totalLaws = totalLaws;
		},
		setCurrentPage(state, page) {
			state.currentPage = page;
		},
		setLoading(state, loading) {
			state.loading = loading;
		},
	},
	actions: {
		async getLaws({ commit, state }, search) {
			const searchQuery = search ? `search:"${search}", ` : '';
			const offset = (state.currentPage - 1) * state.itemsPerPage;

			const query = `
        query FilterByApelidosLeis {
          leis(${searchQuery}sort: ["-data_lei"], limit: ${
				state.itemsPerPage
			}, offset: ${offset}) {
            id_lei
            numero_lei
            data_lei
            nome_lei
          }
          leis_aggregated${searchQuery ? `(${searchQuery})` : ''} {
            count { id_lei }
          }
        }
      `;

			try {
				commit('setLoading', true);

				const response = await axios.post(
					'https://api.mylegis.com.br/graphql',
					{ query }
				);

				const { leis, leis_aggregated } = response.data.data;

				commit('setLaws', leis);
				commit('setTotalLaws', leis_aggregated[0].count.id_lei);
			} catch (error) {
				window.console.error('Error fetching laws:', error);
			} finally {
				commit('setLoading', false);
			}
		},
		setPage({ commit, dispatch }, page) {
			commit('setCurrentPage', page);
			dispatch('getLaws');
		},
	},
	getters: {
		totalPages(state) {
			return Math.ceil(state.totalLaws / state.itemsPerPage);
		},
		paginatedLaws(state) {
			return state.laws;
		},
	},
});

export default store;
